import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setIsShowButton } from '../../store/buttonSlice';
import CustomTitle from '../../components/UI/title/CustomTitle';
import Loader from '../../components/Loader/Loader';

import 'swiper/swiper-bundle.css';
import './style.scss';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ReviewsContent from './ReviewsContent';
import PageContent from '../../components/PageContent/PageContent';

export default function Reviews() {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const history = useHistory();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setIsShowButton(false));
    }, []);

    const [progress, setProgress] = useState(0);
    const [title, setTitle] = useState('Processing your answers...');
    const [secondLoader, setSecondLoader] = useState(false);
    const [thirdLoader, setThirdLoader] = useState(false);

    const [isFirstPopupShow, setIsFirstPopupShow] = useState(false);
    const [isSecondPopupShow, setIsSecondPopupShow] = useState(false);
    const [isThirdPopupShow, setIsThirdPopupShow] = useState(false);


    const swiperRef = useRef(null);
    const [swiper, setSwiper] = useState(null);

    const handleNextSlide = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev < 33) return prev + 1;
                if (secondLoader && prev < 66) return prev + 1;
                if (thirdLoader && prev < 100) return prev + 1;
                clearInterval(interval);
                return prev;
            });
        }, 121);

        return () => clearInterval(interval);
    }, [secondLoader, thirdLoader]);

    useEffect(() => {
        if (progress === 33) {
            swiper.slideNext()
            setTitle('Analyzing your business profile...')
            setSecondLoader(true)
        }
        if (progress === 66) {
            swiper.slideNext()
            setTitle('Getting AI copilot ready...')
            setThirdLoader(true)
        }
        if (progress === 100) {
            history.push({
                pathname: '/hello',
                search: `?${queryParams.toString()}`,
            });
        }
    }, [progress])

    return (
        <div className="page reviews page--without-button">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={queryParams.get("top-goal-id") === '1' ? 'Setting up AI copilot to create powerful ads and boost your productivity' : 'Setting up AI copilot to create powerful ads and boost your sales'}
                    />
                    <ReviewsContent setSwiper={setSwiper} />
                </div>

            </PageContent>

            <Loader progress={progress} tripleLoader={true} title={title} />
        </div>
    )
}
